import { lazy } from 'react';
import { retry } from '@/utils/helpers/common';

// Cloud Compass pages
export const CloudSummaryViewPage = lazy(
  () =>
    retry(() => import('@pages/cloud/summary/summary')) as Promise<
      typeof import('@pages/cloud/summary/summary')
    >
);

export const PayerAccountEditPage = lazy(
  () =>
    retry(() => import('@pages/cloud/aws/payer-accounts/edit')) as Promise<
      typeof import('@pages/cloud/aws/payer-accounts/edit')
    >
);

export const PayerAccountCreatePage = lazy(
  () =>
    retry(() => import('@pages/cloud/aws/payer-accounts/create')) as Promise<
      typeof import('@pages/cloud/aws/payer-accounts/create')
    >
);

export const PayerAccountListView = lazy(
  () =>
    retry(() => import('@pages/cloud/aws/payer-accounts/list')) as Promise<
      typeof import('@pages/cloud/aws/payer-accounts/list')
    >
);

export const PayerAccountTabsPage = lazy(
  () =>
    retry(() => import('@pages/cloud/aws/payer-accounts/tabs')) as Promise<
      typeof import('@pages/cloud/aws/payer-accounts/tabs')
    >
);

export const LinkedAccountEditPage = lazy(
  () =>
    retry(() => import('@pages/cloud/aws/linked-accounts/edit')) as Promise<
      typeof import('@pages/cloud/aws/linked-accounts/edit')
    >
);

export const LinkedAccountInformationPage = lazy(
  () =>
    retry(() => import('@pages/cloud/aws/linked-accounts/information')) as Promise<
      typeof import('@pages/cloud/aws/linked-accounts/information')
    >
);

export const BillingAccountListView = lazy(
  () =>
    retry(() => import('@pages/cloud/gcp/billing-accounts/list')) as Promise<
      typeof import('@pages/cloud/gcp/billing-accounts/list')
    >
);

export const BillingAccountTabsPage = lazy(
  () =>
    retry(() => import('@pages/cloud/gcp/billing-accounts/tabs')) as Promise<
      typeof import('@pages/cloud/gcp/billing-accounts/tabs')
    >
);

export const BillingAccountCreatePage = lazy(
  () =>
    retry(() => import('@pages/cloud/gcp/billing-accounts/create')) as Promise<
      typeof import('@pages/cloud/gcp/billing-accounts/create')
    >
);

export const BillingAccountEditPage = lazy(
  () =>
    retry(() => import('@pages/cloud/gcp/billing-accounts/edit')) as Promise<
      typeof import('@pages/cloud/gcp/billing-accounts/edit')
    >
);

export const SubAccountListView = lazy(
  () =>
    retry(() => import('@pages/cloud/gcp/subaccounts/list')) as Promise<
      typeof import('@pages/cloud/gcp/subaccounts/list')
    >
);

export const SubAccountTabsPage = lazy(
  () =>
    retry(() => import('@pages/cloud/gcp/subaccounts/tabs')) as Promise<
      typeof import('@pages/cloud/gcp/subaccounts/tabs')
    >
);

export const SubAccountEditPage = lazy(
  () =>
    retry(() => import('@pages/cloud/gcp/subaccounts/edit')) as Promise<
      typeof import('@pages/cloud/gcp/subaccounts/edit')
    >
);

export const ProjectListView = lazy(
  () =>
    retry(() => import('@pages/cloud/gcp/projects/list')) as Promise<
      typeof import('@pages/cloud/gcp/projects/list')
    >
);

export const CostReportTabs = lazy(
  () =>
    retry(() => import('@pages/cloud/reports/tabs')) as Promise<
      typeof import('@pages/cloud/reports/tabs')
    >
);

export const BillingReportView = lazy(
  () =>
    retry(() => import('@pages/cloud/reports/billing/list')) as Promise<
      typeof import('@pages/cloud/reports/billing/list')
    >
);

export const PayerAccountReportView = lazy(
  () =>
    retry(() => import('@pages/cloud/reports/payer-account/list')) as Promise<
      typeof import('@pages/cloud/reports/payer-account/list')
    >
);

export const ReportApprovalView = lazy(
  () =>
    retry(() => import('@pages/cloud/reports/approval/list')) as Promise<
      typeof import('@pages/cloud/reports/approval/list')
    >
);

export const ResourcesListView = lazy(
  () =>
    retry(() => import('@pages/cloud/resources/list')) as Promise<
      typeof import('@pages/cloud/resources/list')
    >
);

export const TagsListView = lazy(
  () =>
    retry(() => import('@pages/cloud/virtual-tags/list')) as Promise<
      typeof import('@pages/cloud/virtual-tags/list')
    >
);

export const TagsCreatePage = lazy(
  () =>
    retry(() => import('@pages/cloud/virtual-tags/create')) as Promise<
      typeof import('@pages/cloud/virtual-tags/create')
    >
);

export const TagsEditPage = lazy(
  () =>
    retry(() => import('@pages/cloud/virtual-tags/edit')) as Promise<
      typeof import('@pages/cloud/virtual-tags/edit')
    >
);

export const AzureBillingAccountListView = lazy(
  () =>
    retry(() => import('@pages/cloud/azure/billing-accounts/list')) as Promise<
      typeof import('@pages/cloud/azure/billing-accounts/list')
    >
);

export const AzureBillingAccountTabsPage = lazy(
  () =>
    retry(() => import('@pages/cloud/azure/billing-accounts/tabs')) as Promise<
      typeof import('@pages/cloud/azure/billing-accounts/tabs')
    >
);

export const AzureCustomerTabsPage = lazy(
  () =>
    retry(() => import('@pages/cloud/azure/customers/tabs')) as Promise<
      typeof import('@pages/cloud/azure/customers/tabs')
    >
);

export const CustomerEditPage = lazy(
  () =>
    retry(() => import('@pages/cloud/azure/customers/edit')) as Promise<
      typeof import('@pages/cloud/azure/customers/edit')
    >
);

// OCI pages
export const OCITenancyListPage = lazy(
  () =>
    retry(() => import('@pages/cloud/oci/tenancies/list')) as Promise<
      typeof import('@pages/cloud/oci/tenancies/list')
    >
);

export const OCITenancyTabsPage = lazy(
  () =>
    retry(() => import('@pages/cloud/oci/tenancies/tabs')) as Promise<
      typeof import('@pages/cloud/oci/tenancies/tabs')
    >
);
